import produce from 'immer'
import _ from 'lodash'

function customizer(
    objValue,
    srcValue
) {
    // Nếu 1 trong 2 bên là array (kể cả khi bên kia là object do PHP json_encode([]) === "[]"
    // khiến 1 field từng là object rỗng bị trả về dạng array) — luôn thay thế toàn bộ thay vì
    // merge đệ quy, tránh Immer lỗi "only supports setting array indices" khi gán key dạng string
    // lên draft đang là array.
    if (
        _.isArray(objValue) ||
        _.isArray(srcValue)
    ) {
        return srcValue
    }
}

const INITIAL_STATE = {}

export default function (
    state = INITIAL_STATE,
    action
) {
    if (action.entities) {
        const newState = produce(
            state,
            draftState => {
                _.mergeWith(
                    draftState || {},
                    action.entities,
                    customizer
                )
            }
        )
        return newState
    }
    return state
}
